import {State, Module} from '../decorators.js';
import BaseRoute from '../routing';

import {ProfileCtrl, ChangePasswordCtrl, UploadSignatureCtrl, UserNotificationsCtrl} from './ctrls.js';

import main from './main.html';
import profileTpl from './profile.html';
import notificationsTpl from './notifications.html';
import changePasswordTpl from './profile.password.html';
import uploadSignatureTpl from './profile.signature.html';

@Module({
    name: 'app.account',
    modules: [
        BaseRoute,
    ],
})
@State({
    name: 'r.in.top.account',
    url: '/account',
    controller: ProfileCtrl,
    template: main,
    ncyBreadcrumb: {
        label: 'Account',
    },
    abstract: '.profile',
})
@State({
    name: 'r.in.top.account.profile',
    url: '',
    template: profileTpl,
    ncyBreadcrumb: {
        label: 'Profile',
    },
})
@State({
    name: 'r.in.top.account.password',
    url: '/password',
    controller: ChangePasswordCtrl,
    template: changePasswordTpl,
    ncyBreadcrumb: {
        label: 'Change Password',
    },
})
@State({
    name: 'r.in.top.account.notifications',
    url: '/notifications',
    controller: UserNotificationsCtrl,
    template: notificationsTpl,
    ncyBreadcrumb: {
        label: 'Notifications',
    },
})
@State({
    name: 'r.in.top.account.signature',
    url: '/signature',
    controller: UploadSignatureCtrl,
    template: uploadSignatureTpl,
    ncyBreadcrumb: {
        label: 'Upload Signature',
    },
})
export default class States {
}



// WEBPACK FOOTER //
// ./src/app/account/routing.js